import * as React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import PaymentMethod from './paymentMethod';

import { ProductDetailContainer } from '@components/molecules/productDetail/style';

export interface IProductDetailPaymentMethod {
  alt?: string;
  imageUrl: string;
  label: string;
}

export type Props = {
  productDetailPaymentMethods: IProductDetailPaymentMethod[];
};

const ProductDetailPaymentMethods = ({ productDetailPaymentMethods }: Props) => {
  const renderPaymentMethods = productDetailPaymentMethods.map((item) => <PaymentMethod {...item} />);
  const { t } = useTranslation('common');
  return (
    <Box sx={{ bgcolor: '#00532A1A' }}>
      <ProductDetailContainer>
        <Stack sx={{ padding: '40px 0px' }} alignItems="center" justifyContent="center">
          <Typography variant="h3">{t('product_detail.bundle.tab_menu.payment')}</Typography>
          <div>{t('product_detail.bundle.payment.sub_titile')}</div>
          {renderPaymentMethods}
        </Stack>
      </ProductDetailContainer>
    </Box>
  );
};

export default ProductDetailPaymentMethods;
